// extracted by mini-css-extract-plugin
module.exports = {"cmsRotator":"_3sY-JdR","contentWrapper":"_3qcM7-j"};